module.exports = __webpack_public_path__ + "static/img/4.98375ad4.png";